import React from "react";

const STATUS_STYLES = {
  Draft: "bg-slate-100 text-slate-600",
  "In Review": "bg-amber-100 text-amber-700",
  Approved: "bg-emerald-100 text-emerald-700",
  "Revision Needed": "bg-red-100 text-red-700",
};

export function StatusBadge({ status }) {
  const s = status || "Draft";
  return <span data-testid="status-badge" className={`text-[11px] px-2 py-0.5 rounded-full font-semibold ${STATUS_STYLES[s] || STATUS_STYLES.Draft}`}>{s}</span>;
}
